define( function() {
	"use strict";

	return ( /\?/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/rquery.js
// module id = 181
// module chunks = 0